import { labels } from "../constants/recipeListing.constants"
import { deslashify } from "./utils"

// convert filters nested object into an array
export const getFilterClassesInArray = filters => {
  if (!filters) {
    return []
  }
  const result = Object.keys(filters)
    .map(itm => filters[itm])
    .flat()
  return result
}

// update page url with query params when searchTerm, filters and page values
export const updatePageUrl = ({ filtersData, search, pageNo }) => {
  if (typeof window !== "undefined") {
    const pathName = window?.location?.pathname
    let filtersQuery = []
    const params = new URLSearchParams(window.location.search)

    // search query
    const searchQuery = search || ""

    filtersData &&
      Object?.entries(filtersData?.selectFields)?.map(obj => {
        obj[1]?.value !== "" &&
          obj[1]?.value !== "select" &&
          filtersQuery.push({ [obj[0]]: obj[1]?.value })
        return ""
      })

    const filtersCheckQuery = filtersData
      ? Object?.entries(filtersData?.checkboxFields)?.map(
          obj => obj[1]?.checked
        )
      : ""

    // page query
    const pageQuery = pageNo

    let queryParams = ""
    searchQuery
      ? (queryParams += `term=${searchQuery}`)
      : (queryParams += `${"term="}`)
    filtersQuery &&
      filtersQuery?.map(ele =>
        Object?.entries(ele)?.map(itm => {
          const filterType = params?.get(itm[0])
          if (filterType && itm[1] == "" && itm[1] !== "select") {
            return (queryParams += `&${itm[0]}=${filterType}`)
          } else {
            return (queryParams +=
              itm[1] !== "" && itm[1] !== "select"
                ? `&${itm[0]}=${itm[1]}`
                : "")
          }
        })
      )

    queryParams +=
      filtersCheckQuery.length > 0 && filtersCheckQuery[0]
        ? `&earlyCareers=${filtersCheckQuery[0] ? 1 : 0}`
        : ""
    queryParams +=
      pageQuery && queryParams
        ? `&page=${pageQuery}`
        : pageQuery
        ? `page=${pageQuery}`
        : ""

    // add query parm to url if in recipes page(no page reloaded)
    if (
      window?.history?.pushState &&
      deslashify(pathName) === deslashify(labels?.slug)
    ) {
      const newUrl =
        window.location.origin +
        pathName +
        `${queryParams ? "?" + queryParams : ""}`
      // window.location.href = newUrl
      window.history.pushState({}, '', newUrl);
    }
  }
}

export const getUrlValues = () => {
  if (typeof window !== "undefined") {
    const prevFilters = []
    const params = new URLSearchParams(window.location.search)
    for (const [key, value] of params) {
      params.set(key,value)
    }
    for (const [key, value] of params) {
      prevFilters.push({ [key]: value?.replace(/\//g,'') })
    }

    return {
      prevFilters,
    }
  }
}

export const findURLValues = () => {
  let categoryData = ""
  let pageIndex = 1
  let currentPage = 1
  let url = ""
  let newURLData = ""
  let replacedStr = ""
  let urlArray = []
  let newURL = []
  if (typeof window != "undefined") {
    url = new URL(window.location.href)
    if (url?.search) {
      const srchURL = url.search.endsWith("/")
        ? url.search.slice(0, -1)
        : url.search
      if (srchURL.indexOf("page") > -1) {
        urlArray = srchURL?.split("page=")
        if (urlArray[0]?.indexOf("filter") > -1) {
          // if the page url is like "?filter=Brands&ftag=&page=1"
          newURLData = urlArray[0]?.split("&ftag=")
          newURL = newURLData[0]?.split("filter=")
          if (newURL[1] === "") {
            categoryData = ""
          } else {
            replacedStr = newURL[1].replaceAll("+", " ")
            categoryData = replacedStr.replace(/%20/g, " ").replace(/%27/g, "'")
          }
          pageIndex = parseInt(urlArray[1])
        } else {
          categoryData = ""
          pageIndex = parseInt(urlArray[1])
        }
      } else {
        urlArray = srchURL.split("filter=")
        replacedStr = urlArray[1].replaceAll("+", " ")
        categoryData = replacedStr.replace(/%20/g, " ").replace(/%27/g, "'")
        currentPage = 1
      }
    }
    return {
      cat: categoryData ? categoryData : "",
      pageIn: pageIndex ? pageIndex : 1,
      currPage: currentPage ? currentPage : 1,
    }
  }
}
export const strip_html_tags = str => {
  if (str === null || str === "") return false
  else str = str.toString()
  let newStr = str.replaceAll(/<[^>]*>/g, "")
  return newStr.replaceAll("__", "")
}

export const checkForInjection = (value) =>{
  value = value?.trim();
  let specials = /[*|\":<>[\]{}`\\()';&$]/;
  const hasNoSpecial = specials.test(value);
  return !hasNoSpecial 
}